module.exports = __webpack_public_path__ + "img/gooze_crittertoken.30ddd6c.png";